/* eslint-disable react/prop-types */

import React from "react";

import {
  Row,
  Col,
  Collapse,
  Navbar,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ListGroup,
  ListGroupItem,
  Form,
  Input
} from "reactstrap";

import {
  PieChart,
  Settings,
  User,
  LogOut
} from "react-feather";

import { useSessionStore } from "../services/stores";
import { Farms } from "./Farms";
import { useNavigate } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const NavbarDropdown = ({
  children,
  count,
  showBadge,
  header,
  footer,
  icon: Icon
}) => (
  <UncontrolledDropdown nav inNavbar className="mr-2">
    <DropdownToggle nav className="nav-icon dropdown-toggle">
      <div className="position-relative">
        <Icon className="align-middle" size={18} />
        {showBadge ? <span className="indicator">{count}</span> : null}
      </div>
    </DropdownToggle>
    <DropdownMenu end className="dropdown-menu-lg py-0">
      <div className="dropdown-menu-header position-relative">
        {count} {header}
      </div>
      <ListGroup>{children}</ListGroup>
      <DropdownItem header className="dropdown-menu-footer">
        <span className="text-muted">{footer}</span>
      </DropdownItem>
    </DropdownMenu>
  </UncontrolledDropdown>
);

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const NavbarDropdownItem = ({ icon, title, description, time, spacing }) => (
  <ListGroupItem>
    <Row className="g-0 align-items-center">
      <Col xs={2}>{icon}</Col>
      <Col xs={10} className={spacing ? "pl-2" : null}>
        <div className="text-dark">{title}</div>
        <div className="text-muted small mt-1">{description}</div>
        <div className="text-muted small mt-1">{time}</div>
      </Col>
    </Row>
  </ListGroupItem>
);


/**
 * 
 * @returns 
 */
const NavbarComponent = () => {

  const {
    currentUser,
    toggleSidebar,
  } = useSessionStore();

  const navigate = useNavigate();
  const navigateToMainLandingPage = () => {
    navigate('/');
  }

  
  const keycloak = useKeycloak();
  // Log out the current user
  //
  const logOut = () => {
    // Logout from Keycloak with proper redirect
    keycloak.keycloak.logout({
      redirectUri: window.location.origin + '/'
    });
  }

  return (
    <Navbar color="white" light expand style={{borderTopWidth: 1, backgroundColor: 'red'}}>
      <span
        className="sidebar-toggle d-flex"
        onClick={navigateToMainLandingPage}
      >
        <i className="hamburger align-self-center" />
      </span>

      <Collapse navbar>
        <Nav className="ml-auto" navbar>

          <Farms />
          
          <UncontrolledDropdown nav inNavbar>
            <span className="d-inline-block d-sm-none">
              <DropdownToggle nav caret>
                <Settings size={18} className="align-middle" />
              </DropdownToggle>
            </span>
            <span className="d-none d-sm-inline-block">
              <DropdownToggle nav caret>
                <span className="text-dark">{currentUser.fullName}</span>
              </DropdownToggle>
            </span>
            <DropdownMenu end>
              <DropdownItem>
                <User size={18} className="align-middle mr-2" />
                Profil & Compte
              </DropdownItem>
              <DropdownItem>
                <PieChart size={18} className="align-middle mr-2" />
                Analytique
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem>
                <Settings size={18} className="align-middle mr-2" />                
                Configuration & Confidentialite</DropdownItem>
              <DropdownItem onClick={() => logOut()}>
                <LogOut size={18} className="align-middle mr-2" />                
                Quitter</DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
      </Collapse>
    </Navbar>
  );
};

export default NavbarComponent;